'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/function.prototype.name/polyfill.js
// module id = 464
// module chunks = 0